import axios from "axios"
import Cookies from "js-cookie"
import { FIRMFLOWURL } from "./url";
export const cloneService = (service_id) => {
    console.log(service_id);
    return new Promise(async resolve => {
        try {

            const token = Cookies.get('Bearer');
            const response = await axios.post(`${FIRMFLOWURL}api/Service/clone/${service_id}`, null,
                {
                    headers: { 'Authorization': token }
                }
            )
            resolve({
                success: true,
                data: response.data,
                clonedServiceId:
                    response.data?.clonedServiceId || response.data?.serviceId,
            });
        } catch (err) {
            console.log(err)
            if (err.message.includes(401)) {
                Cookies.remove('Bearer');
                window.location.replace('/');
                return;
            }
            resolve({ success: false, message: err.message });
        }
    })
}
